"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function accountApiClient(networkClient) {
    return {
        getMe: async () => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/me`);
        },
        getUser: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.id}`);
        },
        listUsers: async (query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users`, query, config);
        },
        createUser: async (body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users`, body);
        },
        updateUser: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.id}`, body);
        },
        deleteUser: async (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.id}`);
        },
        getUserMetadata: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.id}/metadata`);
        },
        updateUserMetadata: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.id}/metadata`, body);
        },
        getTeamApiKey: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/api-keys/${params.apiKeyId}`);
        },
        listTeamApiKeys: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/api-keys`, query, config);
        },
        createTeamApiKey: async (params, body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/api-keys`, body);
        },
        updateTeamApiKey: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/api-keys/${params.apiKeyId}`, body);
        },
        deleteTeamApiKey: async (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/api-keys/${params.apiKeyId}`);
        },
        renewTeamApiKey: async (params) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/api-keys/${params.apiKeyId}/renew`, undefined);
        },
        getCampaign: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/campaigns/${params.campaignId}`);
        },
        listCampaigns: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}/campaigns`, query, config);
        },
        createCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}/campaigns`, body);
        },
        updateCampaign: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/campaigns/${params.campaignId}`, body);
        },
        deleteCampaign: async (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/campaigns/${params.campaignId}`);
        },
        getTeam: async (params, query) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}`, query);
        },
        listTeams: async (query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams`, query, config);
        },
        createTeam: async (body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams`, body);
        },
        updateTeam: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}`, body);
        },
        deleteTeam: async (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}`);
        },
        getTeamMetadata: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}/metadata`);
        },
        updateTeamMetadata: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}/metadata`, body);
        },
        getTier: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/tiers/${params.id}`);
        },
        listTiers: async (query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/tiers`, query, config);
        },
        createTier: async (body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/tiers`, body);
        },
        updateTier: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/tiers/${params.id}`, body);
        },
        deleteTier: async (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/tiers/${params.id}`);
        },
        getMember: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/members/${params.userId}`);
        },
        listMembers: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}/members`, query, config);
        },
        updateMember: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/members/${params.userId}`, body);
        },
        deleteMember: async (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/members/${params.userId}`);
        },
        getInvitation: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/invitations/${params.invitationId}`);
        },
        listInvitations: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}/invitations`, query, config);
        },
        createInvitation: async (params, body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.id}/invitations`, body);
        },
        updateInvitation: async (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/invitations/${params.invitationId}`, body);
        },
        deleteInvitation: async (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/teams/${params.teamId}/invitations/${params.invitationId}`);
        },
        getUserInvitation: async (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/invitations/${params.id}`);
        },
        listUserInvitation: async (query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/invitations`, query, config);
        },
        answerInvitation: async (params, body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/invitations/${params.id}/answer`, body);
        },
        forceSendNotification: async (body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/notifications/force-send`, body);
        },
        getContext: async (query) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/context`, query);
        },
    };
}
exports.accountApiClient = accountApiClient;
